import React from 'react'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import TextLink from 'components/Luxkit/TextLink'
import Modal from 'components/Luxkit/Modal/Modal'
import config from 'constants/config'

function QueenslandCycloneWarningModal() {
  return (
    <Modal
      title="Booking Disruptions"
      primaryActionText="Yes, I understand"
    >
      <VerticalSpacer gap={20}>
        <BodyTextBlock variant="large">
          Due to Tropical Cyclone Alfred, travel in the region may be disrupted. Our team is here to support you with any questions or concerns.
        </BodyTextBlock>
        <BodyTextBlock variant="large" weight="bold">
          If your flight has been cancelled or changed, or you're reconsidering land travel:
        </BodyTextBlock>
        <BodyTextBlock variant="large">
          If your flight has been cancelled or changed, or if you were planning to travel by car and no longer feel comfortable doing so, please contact us for assistance.
          Our team can review available options and offer guidance on next steps to help you manage any changes. You can reach us on our priority number: <TextLink
            href="tel:61370323334"
            rel="nofollow"
          >+61 3 7032 3334
          </TextLink>
        </BodyTextBlock>
        <Group direction="vertical" gap={20}>
          <BodyTextBlock variant="large" weight="bold">
            If your flight is currently scheduled to operate as planned:
          </BodyTextBlock>
          <BodyTextBlock variant="large">
            There's no immediate action required at this time. However, we encourage you to monitor your flight status regularly, as the situation can evolve quickly.
            Additionally, if you are planning to travel by car, be aware of potential road closures and hazardous conditions due to heavy rainfall and strong winds.
            If your travel plans are impacted, please reach out to us directly, and we'll provide advice and explore any options available to you.
          </BodyTextBlock>
        </Group>
        <Group direction="vertical" gap={20}>
          <BodyTextBlock variant="large">
            Thank you for your patience and understanding. Our team is here to help ensure your travel experience is as smooth as possible.
          </BodyTextBlock>
          <BodyTextBlock variant="large">
            {config.title} Support Team
          </BodyTextBlock>
        </Group>
      </VerticalSpacer>
    </Modal>
  )
}

export default QueenslandCycloneWarningModal
